module.exports = __webpack_public_path__ + "static/media/medicare-sample-card.13d493f8.png";